import React from 'react';
import { formatCurrency } from '../../../../utils/helpers';

import CamposPago from '../../Components/CamposPago';

const PagoForm = ({estudiante, seleccion, abono, tutor, total, pagoInfo, setPagoInfo, page, fecha}) => {
    const isAbono = total > abono;
    return (
        <div
            className={`body-transferencia page-${page}`}
        >
            <input type="hidden" name="total" value={abono} />
            <div className="transferencia-page py-0">
                <CamposPago
                    pagoInfo={pagoInfo}
                    setPagoInfo={setPagoInfo}
                    total={total}
                    fecha={fecha}
                    labelTipoPago="Forma de pago"
                    conTarjetaDebito
                    hiddenTipoPagoPlano
                    montoName="pago_info[monto]"
                />
                {/* <div className="form-group">
                    <label>Comentario</label>
                    <textarea
                        className="form-control"
                        name="pago_info[notas]"
                    ></textarea>
                </div> */}
            </div>
            <div className="transferencia-page py-0">
                <h3
                    className={`text-center ${
                        page === 1 ? "d-none" : "d-block"
                    }`}
                >
                    Confirmación de transacción
                </h3>
                <h4
                    className={`text-center confirmacion-monto ${
                        page === 1 ? "d-none" : "d-block"
                    }`}
                >
                    {isAbono ? "Abono" : "Total"}: {formatCurrency(abono)}
                </h4>

                <div className={`${
                        page === 1 ? "d-none" : "d-block"
                }`}>
                    <div className="row">
                        <div className="col-md-6">
                            <small>Tutor:</small><br/> <strong className='uppercase'>{tutor.nombreCompleto}</strong><br/>
                            <small>Método de pago:</small><br/> <strong className='uppercase'>{pagoInfo.tipo_pago}</strong><br/>
                        </div>
                        <div className="col-md-6">
                            <small>Estudiante:</small><br/> <strong className='uppercase'>{estudiante.nombreCompleto}</strong><br/>
                        </div>
                    </div>

                    <table className="table table-small m-t-25">
                        <thead>
                            <tr>
                                <th>Cuotas a Pagar</th>
                                <th className="text-right">Monto</th>
                            </tr>
                        </thead>
                        <tbody>
                            {seleccion.map(servicio => (
                                <tr key={servicio.id}>
                                    <td>{servicio.nombre}</td>
                                    <td className='text-right'>
                                        <div>{isAbono ? 'Pendiente: ' : ''}{formatCurrency(servicio.restante)}</div>
                                        {isAbono && (
                                            <>
                                                <div>Abono: {formatCurrency(abono)}</div>
                                                <hr />
                                                <div>Restan: {formatCurrency(servicio.restante - abono)}</div>
                                            </>
                                        )}
                                        <input type="hidden" name='seleccion[]' value={servicio.id} />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default PagoForm;
